import {
    Button,
    CardContent,
    FormControl,
    Card,
    FormControlLabel,
    FormGroup,
    Switch,
    TextField,
    FormLabel,
    RadioGroup,
    Radio,
    FormHelperText,
    Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import api from '../../../services/api';
import { ANAO, ASIM } from 'consts';
import PropTypes from 'prop-types';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import ComboPadrao from 'views/Components/ComboPadrao';
import Box from '@material-ui/core/Box';
import { ATIPO_INTERNO, ATIPO_EXTERNO } from '../../../consts';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import { Info as InfoIcon } from '@material-ui/icons';
import { validate } from 'validate.js';
import { formatDateForInput, formatDateTimeISO, formatData, formatarDataBR, validateField } from 'lib/functions';

class EscalaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            escala: {},
            errors: {},
            codcombustivel: [],
            descveiculo: [],
            tipoabastecimento: ATIPO_EXTERNO, //Inicializa com o valor atual
            bombas: [],
            veiculos: [],
            classes: [],
            combustiveis: [],
            isNewRecord: false,
            isView: false,
            schema: {
                data: {
                    presence: { allowEmpty: false, message: 'Data obrigatória!' },
                    length: { maximum: 10 },
                    type: 'date'
                },
                codveiculo: {
                    presence: { allowEmpty: false, message: 'Veículo obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                horimetro_km: {
                    presence: { allowEmpty: false, message: 'Hodômetro inválido!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                qtdlitros: {
                    presence: { allowEmpty: false, message: 'Quantidade de litros obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                precoporlitro: {
                    presence: { allowEmpty: true, message: 'Valor litro obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                nrotanque: {
                    presence: { allowEmpty: false, message: 'Número Tanque obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                valor: {
                    presence: { allowEmpty: true, message: 'Valor total obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codcombustivel: {
                    presence: { allowEmpty: false, message: 'Combustível obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codbomba: {
                    presence: { allowEmpty: false, message: 'Bomba interna obrigatória!' },
                    length: { maximum: 100 },
                    type: 'integer'
                }
            },

            useStyles: makeStyles(theme => ({
                root: {
                    backgroundColor: theme.palette.background.default,
                    height: '100%'
                },
                grid: {
                    height: '100%'
                },
                quoteContainer: {
                    [theme.breakpoints.down('md')]: {
                        display: 'none'
                    }
                },
                quote: {
                    backgroundColor: theme.palette.neutral,
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: 'url(/images/auth.jpg)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                },
                quoteInner: {
                    textAlign: 'center',
                    flexBasis: '600px'
                },
                quoteText: {
                    color: theme.palette.white,
                    fontWeight: 300
                },
                name: {
                    marginTop: theme.spacing(3),
                    color: theme.palette.white
                },
                bio: {
                    color: theme.palette.white
                },
                contentContainer: {},
                content: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                },
                contentHeader: {
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: theme.spacing(5),
                    paddingBototm: theme.spacing(2),
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2)
                },
                logoImage: {
                    marginLeft: theme.spacing(4)
                },
                contentBody: {
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    [theme.breakpoints.down('md')]: {
                        justifyContent: 'center'
                    }
                },
                form: {
                    paddingLeft: 100,
                    paddingRight: 100,
                    paddingBottom: 125,
                    flexBasis: 700,
                    [theme.breakpoints.down('sm')]: {
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(2)
                    }
                },
                title: {
                    marginTop: theme.spacing(3)
                },
                socialButtons: {
                    marginTop: theme.spacing(3)
                },
                socialIcon: {
                    marginRight: theme.spacing(1)
                },
                sugestion: {
                    marginTop: theme.spacing(2)
                },
                textField: {
                    marginTop: theme.spacing(2)
                },
                signInButton: {
                    margin: theme.spacing(2, 0)
                },
                alert: {
                    color: '#FF0000',
                },
                textarea: {
                    width: '100%',
                    minHeight: 80,
                    padding: theme.spacing(1),
                    borderRadius: 4,
                    border: '1px solid #ccc',
                    fontFamily: theme.typography.fontFamily,
                    fontSize: theme.typography.body1.fontSize,
                    resize: 'vertical',
                    marginTop: theme.spacing(1)
                }
            }))
        }
    }

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        if (id >= 0) {
            const response = await api.get(`/escala/${id}`);

            response.data[0].data = formatDateForInput(response.data[0].data);

            this.setState({
                escala: response.data[0],
                isNewRecord: false,
                isView: (currentPath.includes('/view'))
            });

            const veiculos = await api.get(`/veiculo/listforchange/${response.data[0].codveiculo}`);
            this.setState({ veiculos: veiculos.data });

            const bombas = await api.get(`/bomba/listforchange/${response.data[0].codbomba}`);
            this.setState({ bombas: bombas.data });
        } else if (id === 'novo') {
            this.setState({
                isNewRecord: true
            });
            this.state.isNewRecord = true;

            const configuracoes = await api.get(`/configuracoes/1`);
            this.setState({ configuracoes: configuracoes.data[0] });

            let paramsveiculo = `?page=1&limit=500`;
            const veiculos = await api.get(`/veiculo/active/true${paramsveiculo}`);
            this.setState({ veiculos: veiculos.data });

            const categoriascombustivel = await api.get(`/categoriacombustivel/active/true`);
            this.setState({ categoriascombustivel: categoriascombustivel.data });

            const combustiveis = await api.get(`/combustivel/active/true`);
            this.setState({ combustiveis: combustiveis.data });

            const bombas = await api.get(`/bomba/active/true`);

            const { escala } = this.state;

            if (bombas.data.length === 1) {
                escala.codbomba = bombas.data[0].codbomba;
            }
            this.setState({ bombas: bombas.data });

            escala.tipoabastecimento = ATIPO_INTERNO;
            this.setState({ escala: escala });
        }
    }

    /* evento on change componentes */
    OnChange = (event) => {
        const { escala } = this.state;
        const input = event.target;
        const cursorPosition = input.selectionStart;
        const { name, type, value, checked } = event.target;

        let adjustedValue = value;

        // Atualiza o campo digitado
        escala[name] = value;
        this.setState({ escala });

        // Verifica se 'volume' e 'valor total' estão preenchidos para calcular 'preço por litro'
        if (name === 'qtdlitros' || name === 'valor') {
            const volume = parseFloat(escala.qtdlitros);
            const valorTotal = parseFloat(escala.valor);

            if (volume > 0 && valorTotal > 0) {
                escala.precoporlitro = (valorTotal / volume).toFixed(2);
            } else {
                escala.precoporlitro = 0;
            }
        } else if (name === 'precoporlitro') {
            const qtdlitros = parseFloat(escala.qtdlitros);
            const precoporlitro = parseFloat(escala.precoporlitro);
            const valorTotal = (qtdlitros * precoporlitro);
            escala.valor = valorTotal;
        }

        switch (type) {
            case 'radio':
                adjustedValue = Number(value);
                break;
            case 'checkbox':
                if (name === 'inativo') {
                    adjustedValue = checked === false ? ASIM : ANAO;
                }

                if (name === 'solicitadopelocliente') {
                    adjustedValue = checked === false ? ANAO : ASIM;
                }
                break;
            default:
                if (name === 'precoporlitro' || name === 'valor') {
                    adjustedValue = Number(value.replace(/\./g, '').replace(',', '.'));
                } else if (name === 'codveiculo') {
                    const veiculoSelecionado = this.state.veiculos.find(
                        v => v.codveiculo === parseInt(value, 10)
                    );
                    if (veiculoSelecionado) {
                        escala['codcombustivel'] = veiculoSelecionado.codcombustivel;
                    }
                } else if (name === 'nrotanque' && this.state.isNewRecord) {
                    let qtdlitro = (adjustedValue - this.state.configuracoes.ultimonrotanque);
                    if (qtdlitro > 0) {
                        escala['qtdlitros'] = qtdlitro;
                    }
                }
        }

        // Atualiza o estado com o valor ajustado
        escala[name] = adjustedValue;
        this.setState({ escala: escala }, () => {
            if (input.type === 'text') {
                input.setSelectionRange(cursorPosition, cursorPosition);
            }
        });
    };

    /* atualiza dados de abastecimento existente - post */
    atualizaAbastecimento = async () => {
        const { escala } = this.state;
        try {
            const response = await api.put(`/escala/${escala.codhoratrabalho}`, escala);
            if (response.status === 200) {
                this.props.history.push('/front/escala');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* Click salvar */
    onClickSave = () => {
        let errors = {};
        errors = this.validationRequiredFields();
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            if (this.state.isNewRecord) {
                this.insereAbastecimento();
            } else {
                this.atualizaAbastecimento();
            }
        }
    }

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/front/escala');
    }

    /* valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema } = this.state;
        const { escala } = this.state;
        let errors = {};

        const requiredFields = [
            'data',
            'codveiculo',
            'nrotanque',
            'horimetro_km',
            'qtdlitros',
            'precoporlitro',
            'codcombustivel',
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, escala[field], schema);
            if (error) {
                errors[field] = error;
            }
        });

        // Valida apenas o campo relacionado ao tipo de abastecimento
        if (escala.tipoabastecimento === ATIPO_INTERNO) {
            const codbombaError = validateField('codbomba', escala.codbomba, schema);
            if (codbombaError) {
                errors.codbomba = 'Bomba interna obrigatória!';
            }
        }

        /* outras validações */
        if (this.state.isNewRecord) {
            if (this.state.configuracoes.ultimonrotanque >= escala.nrotanque) {
                let tanque = {
                    field: {
                        presence: { allowEmpty: false, message: 'Numeração do tanque inferior ou igual a última numeração' },
                    }
                };
                errors.tanque = tanque;
                this.handleOpenAlert(errors.tanque.field.presence.message);
                return errors;
            }
        }

        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
        }

        return errors;
    }

    /* insere novo abastecimento */
    insereAbastecimento = async () => {
        const { escala } = this.state;
        escala.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'), 10);
        try {
            const response = await api.post(`/escala`, escala);
            if (response.status === 200) {
                this.props.history.push('/front/escala');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    render() {
        const { escala } = this.state;
        const { veiculos } = this.state;
        const { classes } = this.state;
        const { errors } = this.state;
        const { bombas } = this.state;
        const { configuracoes } = this.state;

        return (
            <div>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Horas de Trabalho {escala.codhoratrabalho}
                    </Typography>

                    <br />

                    {/* Cliente - somente exibição */}
                    <Box width="100%">
                        <FormControl
                            className={classes.textField}
                            style={{ width: '60%' }}
                            component="fieldset"
                        >

                            <Typography
                                color="textSecondary"
                                component="p"
                                variant="body2"
                            >
                                Cliente
                            </Typography>


                            <Typography variant="body1">
                                {escala.cliente || ''}
                            </Typography>
                        </FormControl>
                    </Box>

                    <Box width="100%">

                        <Typography
                            color="textSecondary"
                            component="p"
                            variant="body2"
                        >
                            Data
                        </Typography>

                        <Typography variant="body1">
                            {formatarDataBR(escala.data)}
                         
                        </Typography>

                        <FormControl
                            variant="outlined"
                            disabled={this.state.isView}
                            className={classes.textField}
                            style={{
                                position: 'absolute',
                                marginLeft: '0.5rem',
                                width: '30%',
                                visibility: (escala.tipoabastecimento === ATIPO_INTERNO) ? 'visible' : 'hidden',
                                opacity: (escala.tipoabastecimento === ATIPO_INTERNO) ? 1 : 0,
                                transition: 'opacity 0.3s ease-in-out'
                            }}
                        >
                            <ComboPadrao
                                name={'codbomba'}
                                label={'Bomba Interna'}
                                value={escala.codbomba}
                                onChange={this.OnChange}
                                fieldId={'codbomba'}
                                listItems={bombas}
                                fieldDescription={'descbomba'}
                                helperText={errors.codbomba || ''}
                            />
                        </FormControl>
                    </Box>
                    <Box width="100%">

                        <Typography
                            color="textSecondary"
                            component="p"
                            variant="body2"
                        >
                            Veículo
                        </Typography>


                        <Typography variant="body1">
                            {escala.descveiculo || ''}
                        </Typography>

                    </Box>

                    <Box width="100%">

                        <Typography
                            color="textSecondary"
                            component="p"
                            variant="body2"
                        >
                            Serviço / Produto
                        </Typography>


                        <Typography variant="body1">
                            {escala.descservico || ''}
                        </Typography>

                    </Box>

                    {/* Card dos períodos de trabalho */}
                    <Card
                        variant="outlined"
                        style={{ marginTop: 16, marginBottom: 16 }}
                    >
                        <CardContent>
                            <Typography variant="h6">
                                Períodos de trabalho
                            </Typography>

                            <Box display="flex" justifyContent="space-between" marginTop={2}>
                                {/* Período 1 */}
                                <Box width="48%">
                                    <Typography variant="subtitle1">
                                        Período 1
                                    </Typography>
                                    <Box display="flex" justifyContent="space-between" marginTop={1}>
                                        <TextField
                                            className={classes.textField}
                                            label="Hora inicial"
                                            type="time"
                                            name="horainicial1"
                                            value={escala.horainicial1 || ''}
                                            onChange={this.OnChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ step: 300 }}
                                            style={{ marginRight: '0.5rem', width: '48%' }}
                                            disabled={this.state.isView}
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label="Hora final"
                                            type="time"
                                            name="horafinal1"
                                            value={escala.horafinal1 || ''}
                                            onChange={this.OnChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ step: 300 }}
                                            style={{ width: '48%' }}
                                            disabled={this.state.isView}
                                        />
                                    </Box>
                                </Box>

                                {/* Período 2 */}
                                <Box width="48%">
                                    <Typography variant="subtitle1">
                                        Período 2
                                    </Typography>
                                    <Box display="flex" justifyContent="space-between" marginTop={1}>
                                        <TextField
                                            className={classes.textField}
                                            label="Hora inicial"
                                            type="time"
                                            name="horainicial2"
                                            value={escala.horainicial2 || ''}
                                            onChange={this.OnChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ step: 300 }}
                                            style={{ marginRight: '0.5rem', width: '48%' }}
                                            disabled={this.state.isView}
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label="Hora final"
                                            type="time"
                                            name="horafinal2"
                                            value={escala.horafinal2 || ''}
                                            onChange={this.OnChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ step: 300 }}
                                            style={{ width: '48%' }}
                                            disabled={this.state.isView}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>

                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={this.state.isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        variant="contained"
                        onClick={this.onClickCancel}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                        color="secondary"
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div>
        );
    }
}

EscalaForm.propTypes = {
    classes: PropTypes.object.isRequired
};

export default EscalaForm;
